exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-45728558] {\n  width: 6%;\n}\n.custom-paginated-table .action-buttons[data-v-45728558] {\n  width: 100px;\n}\n.card-icon[data-v-45728558] {\n  background: #a745c7 !important;\n}\n.custom-switch[data-v-45728558] {\n  position: absolute;\n  right: 30px;\n  top: -10px;\n  min-width: 130px;\n}\n.custom-switch .md-switch[data-v-45728558] {\n    margin: 0;\n    margin-bottom: 10px;\n}\n.tooltip-container span[data-v-45728558] {\n  display: block;\n  margin-bottom: 4px;\n}\n.tooltip-container span[data-v-45728558]:last-child {\n    margin-bottom: 0;\n}\n", ""]);

// exports
